import { Reducer } from 'redux';
import { Playlist } from '../entities';
import { IDislike, ILike, ISetWishlist, TWishlist } from '../actions';

export type IWishlistState = Playlist;
export const defaultWishlistState = {
  artwork: 'assets/icons/MW-WISHLIST-POCHETTE.png',
  assoMediaEvent: [],
  tracks: 0
};

const getWishlistDetail = ({ assoMediaEvent = [], ...item }: Playlist) => ({
  ...item,
  artwork: 'assets/icons/MW-WISHLIST-POCHETTE.png',
  assoMediaEvent,
  tracks: assoMediaEvent.length
});

export const wishlistReducer: Reducer<IWishlistState> = (
  state: IWishlistState = defaultWishlistState,
  action: ILike | IDislike | ISetWishlist
): IWishlistState => {

  switch (action.type) {
    case TWishlist.LIKE:
      return {
        ...state,
        assoMediaEvent: [...state.assoMediaEvent, action.payload],
        tracks: state.assoMediaEvent.length
      };
    case TWishlist.DISLIKE:
      return {
        ...state,
        assoMediaEvent: state.assoMediaEvent.filter(({ media }) => media.id !== action.payload)
      };
    case TWishlist.SET_WISHLIST:
      return getWishlistDetail(action.payload);
    default:
      return state;
  }
  return state;
};
